import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzToggleSwitchModule } from '@blk/daisy/elements/selection-controls';
import { AdvisoryFeeModule } from '@ddt-web/advisory-fee';
import { AnalyticsModule } from '@ddt-web/analytics';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DcrModule } from '@ddt-web/dcr';
import { DialogModule } from '@ddt-web/dialog';
import { DisclosureModule } from '@ddt-web/disclosure';
import { DomModule } from '@ddt-web/dom';
import { CtaLinkModule } from '@ddt-web/elements';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { SecuritiesTableModule } from '@ddt-web/securities-table';
import { CombinedDataTableModule, StickyTableModule } from '@ddt-web/table';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { BenchmarkComparisonComponent } from './benchmark-comparison/benchmark-comparison.component';
import { CommonPeriodComponent } from './common-period/common-period.component';
import { FeesOverviewComponent } from './fees-overview/fees-overview.component';
import { FeesSkeletonComponent } from './fees/fees-skeleton/fees-skeleton.component';
import { FeesComponent } from './fees/fees.component';
import { FundPerformanceComponent, FundPerformanceSkeletonComponent } from './fund-performance';
import { HistoricalPerformanceComponent } from './historical-performance/historical-performance.component';
import { MstarRankingComponent } from './mstar-ranking';
import { PerformanceChartGroupedLegendComponent } from './performance-chart-grouped-legend/performance-chart-grouped-legend.component';
import { PerformanceDisclosureComponent } from './performance-disclosure/performance-disclosure.component';
import { HypotheticalPerformanceChartComponent } from './performance-overview/hypothetical-performance-chart/hypothetical-performance-chart.component';
import { PerformanceOverviewComponent } from './performance-overview/performance-overview.component';
import { PortfolioDisplayNameRebalancePipe } from './pipes/portfolio-display-name-rebalance.pipe';
import { HypotheticalGrowthValueService } from './services';

@NgModule({
	declarations: [
		FeesComponent,
		FeesSkeletonComponent,
		BenchmarkComparisonComponent,
		FeesOverviewComponent,
		FundPerformanceComponent,
		FundPerformanceSkeletonComponent,
		PortfolioDisplayNameRebalancePipe,
		PerformanceOverviewComponent,
		PerformanceDisclosureComponent,
		CommonPeriodComponent,
		HistoricalPerformanceComponent,
		HypotheticalPerformanceChartComponent,
		PerformanceChartGroupedLegendComponent,
		MstarRankingComponent
	],
	imports: [
		CommonModule,
		ChartModule,
		SharedModule,
		CoreModule,
		CwpNgFrameworkModule,
		DcrModule,
		SecuritiesTableModule,
		DataServiceModule,
		NgxSkeletonLoaderModule,
		StickyTableModule,
		CombinedDataTableModule,
		DisclosureModule,
		DialogModule,
		AnalyticsModule,
		ReactiveFormsModule,
		CtaLinkModule,
		DzSelectModule,
		DzButtonModule,
		DzToggleSwitchModule,
		GenericDirectivesModule,
		DomModule,
		AdvisoryFeeModule
	],
	exports: [
		FeesComponent,
		FeesSkeletonComponent,
		BenchmarkComparisonComponent,
		FeesOverviewComponent,
		FundPerformanceComponent,
		FundPerformanceSkeletonComponent,
		PortfolioDisplayNameRebalancePipe,
		PerformanceOverviewComponent,
		PerformanceDisclosureComponent,
		CommonPeriodComponent,
		HistoricalPerformanceComponent,
		HypotheticalPerformanceChartComponent,
		MstarRankingComponent
	],
	providers: [
		HypotheticalGrowthValueService
	]
})
export class PerformanceModule { }
